import React, { useEffect, useRef, useState } from "react";
import { usePDF, Margin } from 'react-to-pdf';
import { Button, Form, Table, Select } from "antd";
import { ResponsiveLine } from '@nivo/line'
import ProgressModal from '../../../../App/Utils/ProgressModal'
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import SupplierSearchBox from "../../../../Components/SupplierSearchBox";
import { DataProvider } from "../../../DataProvider";
import { FEEDBACK_SCORE_CARD_COLUNMN_DEFS } from "../../../Constants";

var _ = require('lodash');

const ScoreCardReport = (props) => {
    const formRef = useRef();
    const dataProvider = new DataProvider();
    const [showProgress, setShowProgress] = useState(false)
    const [mstProject, setMstProject] = useState([])
    const [feedbackLineChartData, setFeedbackLineChartData] = useState([])
    const [feedbackData, setFeedbackData] = useState([])
    const { toPDF, targetRef } = usePDF({
        filename: 'page.pdf',
        page: {
            margin: Margin.SMALL,
            format: 'A4',
        },
    });

    useEffect(() => { }, [feedbackData])
    useEffect(() => { fetchDropdownValues() }, [])

    const fetchDropdownValues = () => {
        ['MstProject'].forEach((model, index) => {
            dataProvider.getDropdownValues(model)
                .then((response) => {
                    if (response.ok) {
                        response.json().then((data) => {
                            setMstProject(data.results)
                        })
                    } else {
                        response.json().then((responseJson) => {
                            openNotification("error", "Error", responseJson["message"]);
                        });
                    }
                }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
        })
    }

    const onFinish = (values) => {
        const contractorDetails = JSON.parse(values['contractor_name'])
        values['contractor_code'] = contractorDetails['key']
        setShowProgress(true)
        dataProvider.getFeedbackScoreCard(values)
            .then(response => {
                if (response.ok) {
                    response.json().then(responseJson => {
                        setShowProgress(false)
                        setFeedbackData(responseJson['results'])
                        var result = responseJson['results'].reduce((unique, o) => {
                            if (!unique.some(obj => obj.evaluation_period === o.evaluation_period)) {
                                unique.push(o);
                            }
                            return unique;
                        }, []);
                        setFeedbackLineChartData(result.map(item => {
                            return {
                                "id": item['evaluation_period'],
                                "data": [
                                    {
                                        "x": 'Safety',
                                        "y": item['Safety_Overall'],
                                    },
                                    {
                                        "x": 'Quality',
                                        "y": item['Quality_Overall'],
                                    },
                                    {
                                        "x": 'Time Schedule',
                                        "y": item['Time Schedule_Overall'],
                                    },
                                    {
                                        "x": 'Discipline & Compliance',
                                        "y": item['Discipline & Compliance_Overall'],
                                    },
                                    {
                                        "x": 'Improvement & Initiative',
                                        "y": item['Improvement & Initiative_Overall'],
                                    }
                                ]
                            }
                        }));
                        if (Object.values(responseJson['results']).length == 0) {
                            openNotification("error", "Error", "No feedback found!")
                        } else {
                            openNotification("success", "Success", responseJson["message"])
                        }
                    })
                } else {
                    setShowProgress(false)
                    response.json().then(responseJson => {
                        openNotification("error", "Error", responseJson["message"])
                    })
                }
            }).catch(error => {
                setShowProgress(false)
                console.error(error)
                openNotification("error", "Error", "Error connecting server")
            })

    }

    return (
        <div ref={targetRef}>
            <ProgressModal showProgress={showProgress} />
            <Form
                className="ant-form ant-form-vertical"
                ref={formRef}
                onFinish={onFinish}
            >
                <div className="row form-box" style={{ paddingTop: "10px" }}>
                    <div className="col-lg-4 col-md-12">
                        <Form.Item
                            name={"contractor_name"}
                            label="Contractor Name"
                            rules={[{ required: true, message: "Please enter Contractor Name" }]}>
                            <SupplierSearchBox
                                formRef={formRef}
                                mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                                decorator="contractor_name"
                                placeholder="Enter Contractor Name" />
                        </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <Form.Item
                            name={"project"}
                            label="Project"
                            rules={[{ required: true, message: "Please select project" }]}>
                            <Select
                                allowClear
                                showSearch
                                placeholder="Select Project"
                                options={mstProject.map((val) => ({
                                    value: val.project_id,
                                    label: val.project_name,
                                }))} />
                        </Form.Item>
                    </div>
                    <div className="col-lg-4 col-md-12" style={{ paddingTop: "30px" }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            Submit
                        </Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button
                            onClick={() => {
                                openNotification("warning", "Export to PDF", "Please wait, file will download shortly")
                                toPDF()
                            }}
                            type="primary"
                            htmlType="submit"
                        >
                            Download Report
                        </Button>
                    </div>
                    <div className="col-lg-6 col-md-12" style={{ marginBottom: "20px", marginTop: "10px" }}>
                        <Table
                            size="small"
                            bordered={true}
                            columns={FEEDBACK_SCORE_CARD_COLUNMN_DEFS}
                            pagination={false}
                            dataSource={_.cloneDeep(feedbackData)}
                        />
                    </div>
                    <div className="col-lg-6 col-md-12" style={{ marginBottom: "20px", marginTop: "10px", height: "300px" }}>
                        <ResponsiveLine
                            data={feedbackLineChartData}
                            enableGridX={false}
                            enableGridY={false}
                            enablePointLabel={true}
                            margin={{ top: 20, right: 110, bottom: 30, left: 60 }}
                            xScale={{ type: 'point' }}
                            yScale={{
                                type: 'linear',
                                min: 'auto',
                                max: 'auto',
                                stacked: false,
                                reverse: false
                            }}
                            yFormat=" >-.2f"
                            pointSize={10}
                            pointColor={{ theme: 'background' }}
                            pointBorderWidth={2}
                            pointBorderColor={{ from: 'serieColor' }}
                            pointLabelYOffset={-12}
                            enableTouchCrosshair={true}
                            useMesh={true}
                            legends={[
                                {
                                    anchor: 'bottom-right',
                                    direction: 'column',
                                    justify: false,
                                    translateX: 100,
                                    translateY: 0,
                                    itemsSpacing: 0,
                                    itemDirection: 'left-to-right',
                                    itemWidth: 80,
                                    itemHeight: 20,
                                    itemOpacity: 0.75,
                                    symbolSize: 12,
                                    symbolShape: 'circle',
                                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                                    effects: [
                                        {
                                            on: 'hover',
                                            style: {
                                                itemBackground: 'rgba(0, 0, 0, .03)',
                                                itemOpacity: 1
                                            }
                                        }
                                    ]
                                }
                            ]}
                        />
                    </div>
                </div>
            </Form>
        </div>

    );
};

export default ScoreCardReport;
